import { Locale } from '@/interfaces'
import { en } from './en/en'
import { enEmails } from '././en/emails'
import { de } from './de/de'

export const LocaleMessages: Locale = {
  en: Object.assign(en, enEmails),
  de: de,
}
